import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-phone\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.641575 897.959719m-41.95899 0a41.95899 41.95899 0 1 0 83.91798 0 41.95899 41.95899 0 1 0-83.91798 0Z\" p-id=\"2050\" /><path d=\"M762.004192 1024H261.960813a109.744281 109.744281 0 0 1-109.650962-109.650961V109.650961A109.744281 109.744281 0 0 1 261.960813 0h500.078374a109.744281 109.744281 0 0 1 109.650962 109.650961v804.721408a109.744281 109.744281 0 0 1-109.685957 109.627631zM261.960813 40.827486a68.823476 68.823476 0 0 0-68.823476 68.823475v804.721408a68.823476 68.823476 0 0 0 68.823476 68.823475h500.078374a68.823476 68.823476 0 0 0 68.823476-68.823475V109.650961a68.823476 68.823476 0 0 0-68.823476-68.823475z\" p-id=\"2051\" /><path d=\"M171.40545 767.171785h682.47225v40.827486H171.40545z\" p-id=\"2052\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/phone.svg
// module id = 7pRf
// module chunks = 50